import { MatSnackBar } from '@angular/material';
import { CustomSnackBarComponent } from '@core/components/custom-snackbar/custom-snackbar.component';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '../../../@fuse/services/translation-loader.service';
import { sentry } from '../../../sentry';
import { getErrorCode } from '../utils/get-error-code';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { KNOW_ERRORS } from './know-errors';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../../@fuse/services/translation-loader.service";
var CustomMessagesService = /** @class */ (function () {
    function CustomMessagesService(snackBar, translateService, fuseTranslationLoaderService) {
        this.snackBar = snackBar;
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CustomMessagesService.prototype.info = function (key, params) {
        this.openSnackBar({ key: key, type: 'info', params: params });
    };
    CustomMessagesService.prototype.custom = function (key, icon, params) {
        this.openSnackBar({ icon: icon, key: key, type: 'custom', params: params });
    };
    CustomMessagesService.prototype.success = function (key, params, action) {
        this.openSnackBar({ key: key, type: 'success', params: params, action: action });
    };
    CustomMessagesService.prototype.error = function (key, params) {
        if (key instanceof Error) {
            key = KNOW_ERRORS[getErrorCode(key)] || 'ERRORS.UNKNOWN';
            if (key === 'ERRORS.UNKNOWN') {
                sentry.captureException(key);
            }
        }
        this.openSnackBar({ key: key, type: 'error', params: params });
    };
    CustomMessagesService.prototype.copied = function (key, params) {
        this.openSnackBar({ key: key, type: 'copied', params: params });
    };
    CustomMessagesService.prototype.openSnackBar = function (_a) {
        var icon = _a.icon, key = _a.key, params = _a.params, type = _a.type, action = _a.action;
        this.snackBar.openFromComponent(CustomSnackBarComponent, {
            duration: 5000,
            horizontalPosition: 'left',
            panelClass: 'custom-snackbar--white-background',
            data: {
                type: type,
                icon: icon,
                action: action,
                message: this.translateService.instant(key, params || {}),
            }
        });
    };
    CustomMessagesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomMessagesService_Factory() { return new CustomMessagesService(i0.ɵɵinject(i1.MatSnackBar), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.FuseTranslationLoaderService)); }, token: CustomMessagesService, providedIn: "root" });
    return CustomMessagesService;
}());
export { CustomMessagesService };
